module.exports = __webpack_public_path__ + "img/html-evolution-12.eccab765.jpg";